import axios, {
  AxiosResponse,
  AxiosError,
  AxiosProgressEvent,
  AxiosRequestConfig,
  isAxiosError,
  RawAxiosRequestConfig,
} from "axios";

export type IResponse = AxiosResponse;
export type IErrorResponse = AxiosError;
export type IApiResponse<T, D> = AxiosResponse<T, D>;
export type IResponseStatus = AxiosResponse["status"];
export type IProgressEvent = AxiosProgressEvent;

export const isApiError = isAxiosError;

const createApi = ({
  baseURL,
  headers,
}: { baseURL?: string; headers?: RawAxiosRequestConfig["headers"] } = {}) => {
  const axiosInstance = axios.create({
    baseURL,
    headers,
  });

  const setHeader = (key: string, value: string) => {
    axiosInstance.defaults.headers.common[key] = value;
  };

  const setAuthToken = (token: string) => {
    setHeader("Authorization", `Bearer ${token}`);
  };

  const isAuthHeaderSet = () => {
    return !!axiosInstance.defaults.headers.common.Authorization;
  };

  const token = localStorage.getItem("Authorization");

  if (token) {
    setAuthToken(token);
  }

  return {
    get: <P, R>(path: string, params?: P) =>
      axiosInstance.get<R>(path, { params }),
    post: <B, R>(path: string, data?: B, config?: AxiosRequestConfig<B>) =>
      axiosInstance.post<R, IApiResponse<R, B>, B>(path, data, config),
    put: <B, R>(path: string, data?: B, config?: AxiosRequestConfig<B>) =>
      axiosInstance.put<R, IApiResponse<R, B>, B>(path, data, config),
    patch: <B, R>(path: string, data?: B, config?: AxiosRequestConfig<B>) =>
      axiosInstance.patch<R, IApiResponse<R, B>, B>(path, data, config),
    delete: <R>(path: string) => axiosInstance.delete<R>(path),
    setAuthToken,
    isAuthHeaderSet,
    setHeader,
    isApiError,
    _instance: axiosInstance,
  };
};

export default createApi;
